module.exports = __webpack_public_path__ + "img/cbd0286.png";